<div class="login-form d-flex flex-column-center">
  <div>
    @if (firstTime) {
      <h2>{{ "login.set_password" | translate }}</h2>
    }
    @if (!firstTime) {
      <h2>{{ "change_password.reset_password" | translate }}</h2>
    }
    <h3>{{this.email}}</h3>
  </div>

  <div>

    @if (errorMessage) {
      <div class="error-container">
        {{this.errorMessage}}
      </div>
    }

    <app-change-password-form actionButtonLabel="{{firstTime ? 'login.set_password' : 'change_password.reset_password'}}" (changePassword)="setPassword($event)"
    [buttonLoading]="buttonLoading" [hideCurrentPassword]="true"></app-change-password-form>
  </div>

  <uw-language-selector></uw-language-selector>

</div>
